<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>

<mat-form-field appearance="outline" class="search-field">
  <mat-label>Buscar por título</mat-label>
  <img
    matPrefix
    src="../../../../../assets/svg/icons/search.svg"
    alt="Lupa"
    class="search-icon"
  />
  <input
    matInput
    type="text"
    placeholder=" "
    (input)="updateFieldText($event)"
  />
</mat-form-field>

<table mat-table [dataSource]="notificacoes" class="cis-default-table" matSort>
  <ng-container *ngFor="let coluna of colunasTabela" [matColumnDef]="coluna.id">
    <th
      mat-header-cell
      class="header"
      *matHeaderCellDef
      mat-sort-header
      disableClear
    >
      {{ coluna.header }}
    </th>
    <td
      mat-cell
      *matCellDef="let notificacao"
      [ngClass]="{
        'highlight-nao-visualizado': notificacao.status === 'nao_visualizado'
      }"
    >
      <ng-container [ngSwitch]="coluna.propriedade">
        <ng-container *ngSwitchDefault>
          {{ formatarValor(notificacao, coluna) }}
        </ng-container>
      </ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    [ngClass]="getStatusClass(row.status)"
    (click)="openDetailsModal(row)"
  ></tr>
</table>

<div class="paginator-container">
  <p>Mostrando {{ inicio }} a {{ fim }} de {{ total }} resultados</p>

  <mat-paginator
    [length]="total"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="false"
    (page)="atualizarContagem($event.pageIndex, $event.pageSize)"
    [selectConfig]="{
      disableOptionCentering: true,
      panelClass: 'custom-paginator-select'
    }"
  >
  </mat-paginator>
</div>
